<app-modal-window title="Выдать бесплатные кейсы"
                  [actions]="true"
                  (close)="close()"
                  (confirm)="addFreeUserCase()">

  <div class="add-free-cases-user-content">
    <form [formGroup]="addFeeCaseForm">

      <div class="form-container">

        <mat-form-field appearance="outline" class="count">
          <mat-label>Количество</mat-label>
          <input matInput type="number" id="count" formControlName="count" placeholder="кол-во">
        </mat-form-field>

        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Беплатные кейсы</mat-label>
          <mat-select formControlName="freeCaseId"
                      [disableOptionCentering]="true"
                      panelClass="add-free-user-case">
            <ng-container *ngIf="allFreeCases$ | async as allFreeCases">
              <mat-option *ngFor="let item of  allFreeCases"
                          [value]="item.id"
                          (click)="setSelectedCase(item)">
                {{item.name}}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>

    </form>

    <mat-card class="selected-case-container" *ngIf="selectedFreeCase">
      <div class="case-item" *ngFor="let item of selectedFreeCase.freeCases; let i=index">
        <span>{{i+1}}.</span>
        <span>{{item.case.name}}</span>
      </div>
    </mat-card>
  </div>
</app-modal-window>



